<template>
<page :title="i18n.title_cd">
  <div class="main-box">
    <div class="coupon-head">
      <div class="coupon-input">
        <input type="text" v-model="code" :placeholder="i18n.input_tips"/>
        <button :class="!code? 'coupon-btn':'coupon-btn coupon-btn-active'" :disabled="!code" @click="sendCoupon">{{i18n.btn}}</button>
      </div>
      <div class="coupon-type">
        <div class="coupon-type-item" @click="state = '0'">
          <span :class="{'is-checkbox': state === '0'}">{{i18n.coupon_toBeUsed}}</span>
        </div>
        <div class="coupon-type-item" @click="state = 'buy'">
          <span :class="{'is-checkbox': state === 'buy'}">{{i18n.coupon_buy}}</span>
        </div>
        <div class="coupon-type-item" @click="state = '3'">
          <span :class="{'is-checkbox': state === '3'}">{{i18n.coupon_haveBeenUsedOrPastDue}}</span>
        </div>
      </div>
    </div>
    <div class="coupon-content">
      <div class="coupon-warp" v-if="couponList.length > 0">
        <!-- v-if="type === 'INNER'" -->
          <div v-for="(item, i) in couponList" :key="i">
            <div class="coupon-card" @click="onCoupon(item)">
              <!-- <img class="coupon-card-bg" src="../../assets/imgs/coupon_bg_zh.png" mode=""/> -->
              <div v-if="state !== '3'">
                <img class="coupon-card-bg" v-if="lang==='en-US'" src="../../assets/imgs/coupon_bg_en.png" mode=""/>
                <img class="coupon-card-bg" v-else src="../../assets/imgs/coupon_bg_zh.png" mode=""/>
              </div>
              <div v-else>
                <img class="coupon-card-bg" v-if="lang==='en-US'" src="../../assets/imgs/coupon_bg_en_invalid.png" mode=""/>
                <img class="coupon-card-bg" v-else src="../../assets/imgs/coupon_bg_zh_invalid.png" mode=""/>
              </div>
              <div class="coupon-neibu">
                <div class="title">{{item.ruleName? item.ruleName:item.pName }}</div>
                <div class="coupon-item-foot">
                  <div class="tips">{{i18n.deadline}}</div>
                  <span>：</span>
                  <div class="date" v-if="lang==='en-US'">{{item.pEnd.substring(0, 10)}}</div>
                  <div class="date" v-else>{{item.pEnd.substring(0, 10)}}</div>
                </div>
              </div>
              <img v-if="item.ruleLogo && state !== '3'" class="coupon-card-logo" :src="item.ruleLogo" mode=""/>
              <img v-else-if="item.ruleType && state !== '3'" class="coupon-card-logo" src="../../assets/imgs/coupon_logo.png" mode=""/>
              <!-- <div v-else :class="[{'coupon-list-logo_en': lang==='en-US'},{'coupon-list-logo_hk': lang==='zh-HK'}]" @click.stop="onSubmit(item.pId)">
                <span>{{i18n.coupon_buy}}</span>
              </div> -->
              <!-- <div v-else-if="browser === 'mpay'" :class="[{'coupon-list-logo_en': lang==='en-US'},{'coupon-list-logo_hk': lang==='zh-HK'}]" @click.stop="onSubmit(item.pId)">
                <span>{{i18n.coupon_buy}}</span>
              </div> -->
              <div v-else :class="[{'coupon-list-logo_en': lang==='en-US'},{'coupon-list-logo_hk': lang==='zh-HK'}]" @click.stop="onPay(item)">
                <span>{{i18n.coupon_buy}}</span>
              </div>
            </div>
          </div>
      </div>
      <!-- <result-msg v-else @click="getCouponList(1)"></result-msg> -->
      <div v-else class="result">
        <img src="../../assets/imgs/result_list.png">
      </div>
      <div v-if="noMore" class="coupon-no-more"><span></span>--<span>{{i18nMsg.no_more}}</span><span>--</span></div>
    </div>
    <paytype v-if="payTypeShow" ref="paytype" :payTitle="i18nMsg.payTitle" :paySubTitle="i18nMsg.paySubTitle" :pPrice="pPrice" :payTypeShow="payTypeShow" @back="onBack" @changeRadio="changeRadio" @goPay="goPay" />
  </div>
</page>
</template>

<script>
import { COUPON_RECORD, COUPON_SEND, COUPON_LIST } from '../../apis/user.js'
import { EFTPAY_COUPON, YEDPAY_PAY_COUPON, MPAY_BUY_COUPON, PAYPAL_BUYCOUPON, WEPAYEZ_COUPONCD } from '../../apis/payment'
import { mapState } from 'vuex'
// import ResultMsg from '../../components/result/msg.vue'
export default {
  computed: {
    ...mapState(['lang', 'browser', 'area']),
    i18n () {
      return this.$t('coupon')
    },
    i18nMsg () {
      return this.$t('msg')
    },
    i18nConfirm () {
      return this.$t('confirm')
    }
  },
  watch: {
    state (val, oldval) {
      if (val) {
        console.log(val)
        this.getCouponList(1)
      }
    }
  },
  data () {
    return {
      couponList: [],
      page: 1,
      noMore: false,
      code: '',
      pCategory: 1,
      state: 'buy',
      payTypeShow: false,
      pPrice: 0,
      pId: '',
      payTypeValue: 'AlipayCN',
      pay: process.env.VUE_APP_PAY === '1'
    }
  },
  created () {
    this.getCouponList(1)
  },
  methods: {
    onBack (v) {
      this.payTypeShow = v
    },
    changeRadio (v) {
      console.log('radio', v.index, v.value)
      this.payTypeValue = v.value
    },
    onPay (item) {
      this.pPrice = item.pPrice
      this.pId = item.pId
      this.payTypeShow = true
    },
    goPay (v) {
      this.payTypeValue = v
      this.onSubmit(1)
    },
    getCouponList (page = 1) {
      let url = COUPON_RECORD
      let params = {
        page: page,
        limit: 10,
        type: 'INNER_AMOUNT',
        state: this.state
      }
      if (this.state === 'buy') {
        url = COUPON_LIST
      }
      this.$loading(true)
      this.$get(
        url,
        params,
        res => {
          this.$loading(false)
          this.page = page
          if (res.list) {
            this.noMore = res.list.current >= res.list.pages
            if (page > 1) {
              this.couponList = [...this.couponList, ...res.list.records]
            } else {
              this.couponList = [...res.list.records]
            }
          }
        },
        err => {
          this.$loading(false)
          this.$toast(err)
        }
      )
    },
    sendCoupon () {
      this.$loading(true)
      this.$post(
        COUPON_SEND,
        {
          code: this.code
        },
        res => {
          this.$loading(false)
          this.$toast(res.msg)
          this.getCouponList()
        },
        err => {
          this.$loading(false)
          this.$toast(err)
        }
      )
    },
    onCoupon (item) {
      this.$store.commit('coupon', item)
      if (item.ruleType === 'INNER_AMOUNT') {
        this.$router.push('/coupon_detail')
      } else {
        // this.onSubmit(item.pId)
      }
    },
    onSubmit (id) {
      if (this.browser === 'mpay') {
        this.mpayBuyCoupon(id)
        return
      } else if (this.payTypeValue === 'Paypal') {
        this.onPaypal()
        return
      } else if (this.payTypeValue === 'WeChat') {
        this.onWechat()
        return
      }
      console.log('pay', this.pay)
      this.$loading(true)
      this.$post(
        this.pay ? EFTPAY_COUPON : `${YEDPAY_PAY_COUPON}?couponId=${this.pId}&num=1`,
        {
          couponId: this.pId,
          num: 1,
          apiType: 'H5',
          payChannel: this.payTypeValue,
          returnUrl: window.location.href
        },
        res => {
          this.$loading(false)
          console.log(res)
          if (res.data && res.data.pay_apptrade) {
            window.location.href = res.data.pay_apptrade
          } else {
            this.$toast(res.msg)
          }
        },
        error => {
          this.$loading(false)
          console.log(error)
          this.$toast(error)
        }
      )
    },
    mpayBuyCoupon (id) {
      // let vm = this
      this.$loading(true)
      this.$post(
        `${MPAY_BUY_COUPON}?couponId=${id}&num=1&apiType=QRCODE&payChannel=mpay`,
        {},
        res => {
          this.$loading(false)
          console.log(res)
          // if (window.mp) {
          //   window.mp.choosePayMent({
          //     paymentData: JSON.parse(res.data.data.pay_info),
          //     success: function (res) { // 支付成功回調 以下是 res 示例
          //       console.log('支付成功----', res)
          //       // vm.$emit('loadlist')
          //       vm.$toast(vm.i18nMsg.success)
          //       // window.location.reload()
          //     },
          //     fail: function (error) {
          //       console.log('mpay支付失败---', error)
          //       vm.$toast(error)
          //     }, // 支付失敗回調
          //     cancel: function (res) { // 以下是 res 內容示例
          //       console.log('mpay取消支付---', res)
          //     } // 取消支付回調
          //   })
          // } else {
          //   this.loadMpayScript(this.mpayBuyCoupon)
          // }
          if (res.data && res.data.qr_code) {
            window.location.href = res.data.qr_code
          } else {
            this.$toast(res.msg)
          }
        },
        error => {
          this.$loading(false)
          console.log(error)
          this.$toast(error)
        }
      )
    },
    onPaypal () {
      this.$loading(true)
      let url = PAYPAL_BUYCOUPON
      this.$post(
        url,
        {
          couponId: this.pId
        },
        resp => {
          this.$loading(false)
          if (resp.data) {
            this.$loading(true)
            window.location.href = resp.data.checkOutUrl
          }
        },
        error => {
          this.$loading(false)
          this.$confirm({
            title: this.i18nConfirm.msg_fail_title,
            content: this.i18nConfirm.msg_fail_order,
            confirmText: this.i18nConfirm.msg_fail_retry,
            cancelText: this.i18nConfirm.msg_fail_cancel
          }).then(() => {
            this.onPaypal()
          })
          console.log(error)
        }
      )
    },
    onWechat () {
      this.$loading(true)
      let url = `${WEPAYEZ_COUPONCD}?couponId=${this.pId}&num=1`
      this.$post(
        url,
        {},
        resp => {
          this.$loading(false)
          if (resp.data) {
            this.$loading(false)
            this.$confirmqr({
              title: this.i18nConfirm.msg_fail_title,
              text: resp.data.code_url,
              tip: this.i18nMsg.confirmpaytip,
              confirmText: this.i18nConfirm.msg_fail_payconfirm,
              cancelText: this.i18nConfirm.msg_fail_cancel
            }).then(() => {
              this.payTypeShow = false
            })
            // window.location.href = resp.data.code_url
          }
        },
        error => {
          this.$loading(false)
          this.$confirm({
            title: this.i18nConfirm.msg_fail_title,
            content: this.i18nConfirm.msg_fail_order,
            confirmText: this.i18nConfirm.msg_fail_retry,
            cancelText: this.i18nConfirm.msg_fail_cancel
          }).then(() => {
            this.onWechat()
          })
          console.log(error)
        }
      )
    }
  }
}
</script>

<style lang="less" scoped>
  .main-box {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: space-around;
    position: relative;
  }
  .coupon-head {
    padding-top: 90px;
    position: fixed;
    width: 100%;
    top: 0;
    background: #fff;
    z-index: 98;
  }
  .coupon-content {
    margin-top: 200px;
  }
  .coupon-card {
    width: 700px;
    height: 202px;
    margin: 40px auto;
    // background-image: url('../../static/imgs/coupon_bg1.png');
    // background-size: 100% 100%;
    position: relative;
    color: #FFFFFF;
    font-size: 28px;
    .coupon-card-bg {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 9;
    }
    .coupon-neibu {
      z-index: 96;
      position: absolute;
      top: 18px;
      left: 66px;
      font-size: 24px;
      .title {
        width: 450px;
        font-size: 36px;
        font-weight: 600;
        // border-bottom: 2px solid #FFFFFF;
        // padding: 20px 0;
        margin-bottom: 6px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
      .coupon-item-foot {
        display: flex;
        flex-direction: row;
        margin-top: 40px;
      }
    }
    .coupon-card-logo {
      position: absolute;
      z-index: 88;
      top: 50px;
      right: 20px;
      height: 100px;
      width: 100px;
      border-radius: 50%;
    }
    .coupon-list-logo_en {
      position: absolute;
      z-index: 88;
      top: 80px;
      right: 16px;
      font-size: 28px;
    }
    .coupon-list-logo_hk {
      position: absolute;
      z-index: 88;
      top: 60px;
      right: 16px;
      width: 50px;
      font-size: 28px;
    }
    .coupon-val {
      position: absolute;
      top: 10px;
      left: 210px;
    }
    .coupon-date {
      position: absolute;
      top: 100px;
      left: 210px;
      text-align: right;
    }
    .coupon-big {
      font-size: 72px;
      font-weight: 500;
    }
  }
  .coupon-no-more {
    color: #666666;
    font-size: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .coupon-no-more text {
    padding: 32px;
    color: #666666;
    font-size: 28px;
    background: rgba(249,249,249,1);
    z-index: 89;
  }
  .coupon-input {
    display: flex;
    padding: 20px;
    input {
      flex: 1;
      height: 60px;
      font-size: 28px;
      background-color: #FFFFFF;
      padding: 0 20px;
      margin-right: 20px;
    }
    .coupon-btn {
      -webkit-tap-highlight-color: transparent;
      border-radius: 5px;
      box-sizing: border-box;
      cursor: pointer;
      display: block;
      margin-left: auto;
      margin-right: auto;
      overflow: hidden;
      padding-left: 14px;
      padding-right: 14px;
      position: relative;
      text-align: center;
      text-decoration: none;
      color: hsla(0,0%,100%,.6);
      background-color: rgba(184, 4, 91,0.32);
      display: inline-block;
      line-height: 2.3px;
      padding: 0 1.34em;
      border: none;
    }
    .coupon-btn-active {
      background-color: #b8045b;
      color: #fff;
    }
  }
  .coupon-type {
    display: flex;
    background-color: #FFFFFF;
    font-size: 28px;
    .coupon-type-item {
      width: 370px;
      flex: 1;
      text-align: center;
      span {
        display: inline-block;
        height: 80px;
        line-height: 80px;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
    }
    .coupon-type-item + .coupon-type-item {
      border-left: 1px dashed #DCDFE6;
    }
    .is-checkbox {
      border-bottom: 4px solid #b8045b;
    }
  }
  .coupon-warp {
    // height: calc(100vh - 300px);
    // width: 100%;
    // padding-top: 200px;
    // overflow: scroll;
    // position: fixed;
    // padding-bottom: 100px;
  }
  .coupon-card-shop {
    background-color: #fff;
    border: 1px solid #03a6de;
    margin: 20px;
    padding: 20px;
    display: flex;
    border-radius: 10px;
    .coupon-card-logo-shop {
      width: 250px;
      height: 250px;
      border-radius: 10px;
      margin-right: 20px;
    }
    .coupon-neibu-shop {
      width: 300px;
      flex: 1;
      font-size: 24px;
      color: #909399;
      .title {
        color: #303133;
        font-size: 32px;
        font-weight: 600;
      }
      .line {
        width: 250px;
        height: 2px;
        margin: 6px 0;
        background-color: #909399;
      }
    }
  }
  .coupon-category-list {
    padding: 20px 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 24px;
    color: #303133;
    .coupon-category-item {
      background-color: #EBEEF5;
      padding: 10px 20px;
      border-radius: 8px;
    }
    .isOpt {
      background-color: #b8045b;
      color: #fff;
    }
  }
  .result {
    height: 1220px;
    background: #FFFFFF;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;
    margin-top: 40px;
    img {
      width: 600px;
      height: 600px;
    }
  }
</style>
